jQuery(document).ready(function() {  

	jQuery('.alfabet').click(function( event ) {

		event.preventDefault();

		let anchor = jQuery.attr(this, 'href');
	
		if ( jQuery(anchor).length !== 0 ) {

			let pos = parseInt( jQuery( anchor ).offset().top - 160 );
			jQuery('html, body').animate({ scrollTop: pos }, 350);
			return false;

		}

	});
	
});
